module.exports = __webpack_public_path__ + "static/media/Apple Watch 44mm White Ceramic + White Closed.53436a14.png";